<template>
  <div>
    <template>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="6">
              <b-row>
                <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                  <div class="card-body text-center">
                    <div class="mt-1">
                      <img src="images/logofo2.png" class="stylelogocliente" alt="Logo">
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="8">
                  <!-- <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12"><b-form-checkbox value="me"> ¿Es una empresa?</b-form-checkbox></b-col>
                  </b-row> -->
                  <b-row>
                    <template v-if="mostrarEditRazonSocial">
                     <b-col class="razonSocialCliente" cols="12" sm="12" md="12" lg="12" xl="11"><b-form-input @keyup.enter="actualizarDatos()" v-model="customerData.razonSocial"></b-form-input></b-col>
                    </template>
                    <template v-else>
                      <b-col cols="12" sm="12" md="12" lg="12" xl="11"><h4 class="razonSocialCliente">{{ customerData.razonSocial }}</h4></b-col>
                    </template>
                    <b-col cols="1" class="razonSocialCliente">
                      <button @click="editarRazonSocial()" class="btn btn-primary btn-sm sinresultados"><i class="fas fa-edit"></i></button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12"><h6>{{ customerData.documento }}</h6></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="6">
              <b-row>
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2">
                  <b>DIRECCIONES</b>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                   <b-input-group>
                <b-input-group-text slot="append" is-text >
                  <button title="Mostrar Direcciones" class="btn btn-warning btn-sm sinresultados" v-b-modal.newdirection1 v-b-tooltip.hover @click="mostrarDirecciones()"><i class="fas fa-route"></i></button>
                </b-input-group-text> 
                <b-form-input 
                  placeholder="Direccion del cliente..."
                  disabled
                  v-model="direccionActual"
                ></b-form-input>
                 </b-input-group>
                <!-- <b-button class="index2" variant="" @click="editarDireccion()" title="Editar direccion"><i class="fa fa-1x fa-pencil"></i></b-button> -->
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2">
                  <b>OBSERVACION</b>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <b-input-group>
                    <b-form-input
                      type="text"
                      :disabled="obsDisabled"
                      @keyup.enter="actualizarDatos()"
                      required
                      placeholder="Observaciones"
                      v-model="customerData.observaciones"
                    ></b-form-input>
                    <b-input-group-text slot="append" is-text >
                      <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarObs()"><i class="fas fa-edit"></i></button>
                    </b-input-group-text> 
                </b-input-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2">
                  <b>OBS Proforma</b>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <template v-if="customerData.obsDocs != null">
                    <b-input-group>
                      <b-form-input
                        type="text"
                        :disabled="obsDisabledPro"
                        @keyup.enter="actualizarDatos()"
                        required
                        placeholder="Observaciones Proforma"
                        v-model="customerData.obsDocs[0].obs"
                      ></b-form-input>
                      <b-input-group-text slot="append" is-text >
                        <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarObsPro()"><i class="fas fa-edit"></i></button>
                      </b-input-group-text> 
                    </b-input-group>
                  </template>
                  <template v-else>
                    <b-input-group>
                      <b-form-input
                        type="text"
                        :disabled="obsDisabledPro"
                        @keyup.enter="actualizarDatos()"
                        required
                        placeholder="Observaciones Proforma"
                        v-model="observacionesPro"
                      ></b-form-input>
                      <b-input-group-text slot="append" is-text >
                        <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarObsPro()"><i class="fas fa-edit"></i></button>
                      </b-input-group-text> 
                    </b-input-group>
                </template>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2">
                  <b>OBS Nota Venta</b>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <template v-if="customerData.obsDocs != null">
                    <b-input-group>
                      <b-form-input
                        type="text"
                        :disabled="obsDisabledNV"
                        @keyup.enter="actualizarDatos()"
                        required
                        placeholder="Observaciones Nota de Venta"
                        v-model="customerData.obsDocs[1].obs"
                      ></b-form-input>
                      <b-input-group-text slot="append" is-text >
                        <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarObsNV()"><i class="fas fa-edit"></i></button>
                      </b-input-group-text> 
                    </b-input-group>
                  </template>
                  <template v-else>
                    <b-input-group>
                      <b-form-input
                        type="text"
                        :disabled="obsDisabledNV"
                        @keyup.enter="actualizarDatos()"
                        required
                        placeholder="Observaciones Nota de Venta"
                        v-model="observacionesNV"
                      ></b-form-input>
                      <b-input-group-text slot="append" is-text >
                        <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarObsNV()"><i class="fas fa-edit"></i></button>
                      </b-input-group-text> 
                    </b-input-group>
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="6">
              <b-row>
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2"><b>CELULAR</b> </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                  <b-input-group>
                    <b-form-input
                      type="number"
                      @keyup.enter="actualizarDatos()"
                      :disabled="celular"
                      required
                      placeholder="Celular"
                      v-model = customerData.movil1
                    ></b-form-input>
                    <b-input-group-text slot="append" is-text >
                      <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarCelular()"><i class="fas fa-edit"></i></button>
                    </b-input-group-text> 
                  </b-input-group>
                </b-col>
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2"><b>TELEFONO</b></b-col>
                <b-col class="mt-1" cols="12" sm="12" md="12" lg="12" xl="4">
                  <b-input-group>
                  <b-form-input
                    type="number"
                    @keyup.enter="actualizarDatos()"
                    :disabled="telefono"
                    required
                    placeholder="Telefono"
                    v-model="customerData.telefono"
                  ></b-form-input>
                    <b-input-group-text slot="append" is-text >
                      <button title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="editarTelefono()"><i class="fas fa-edit"></i></button>
                    </b-input-group-text>
                    </b-input-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2"><b>TAG 1</b> </b-col>
                <b-col class="mt-1" cols="12" sm="12" md="12" lg="12" xl="4">
                  <b-input-group>
                    <select class="custom-select" v-model="customerData.tag1">
                        <option value=""> Ingrese Tag </option>
                        <option v-for="tag in listaTag" v-if="tag.numeroTag == 1" :key="tag.id" :value="tag.tag">{{ tag.tag }}</option>
                    </select>
                    <b-input-group-text slot="append" is-text >
                      <button title="Editar" class="btn btn-warning btn-sm sinresultados" @click="actualizarDatos()"><i class="fas fa-edit"></i></button>
                    </b-input-group-text>
                  </b-input-group>
                </b-col>
                  <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2"><b>TAG 2</b> </b-col>
                  <b-col class="mt-1" cols="12" sm="12" md="12" lg="12" xl="4">
                    <b-input-group>
                    <select class="custom-select" v-model="customerData.tag2">
                      <option value=""> Ingrese Tag </option>
                      <option v-for="tag in listaTag" v-if="tag.numeroTag == 2" :key="tag.id" :value="tag.tag">{{ tag.tag }}</option>
                    </select>
                    <b-input-group-text slot="append" is-text >
                      <button title="Editar" class="btn btn-warning btn-sm sinresultados" @click="actualizarDatos()"><i class="fas fa-edit"></i></button>
                    </b-input-group-text>
                    </b-input-group>
                  </b-col>
              </b-row>
              <b-row>
                <b-col class="mt-2" cols="12" sm="12" md="12" lg="12" xl="2"><b>CORREOS</b> </b-col>
                <b-col class="mt-1" cols="12" sm="12" md="12" lg="12" xl="10">
                  <b-input-group
                      label-for="input_correo"
                      :invalid-feedback="invalidFeedbackCorreo"
                      :valid-feedback="validFeedbackCorreo"
                      :state="stateCorreo"
                      description="Ingrese un correo y pulse ENTER, para agregarlo a la lista."
                      >
                      <b-form-input
                        :disabled="sindoc"
                        class="input-dark"
                        type="email"
                        v-model="correo"
                        required
                        @keyup.enter="addCorreo()"
                        :state="stateCorreo"
                        placeholder="Correos para facturación"
                      ></b-form-input>                
                      <b-input-group-text slot="append" is-text >
                        <button v-if="sindoc" title="Habilitar Edición" class="btn btn-primary btn-sm sinresultados" @click="dataContacto()"><i class="fas fa-at"></i></button>
                        <button v-else title="Finalizar Edición" class="btn btn-warning btn-sm sinresultados" @click="actualizarDatos()"><i class="fas fa-at"></i></button>
                      </b-input-group-text>        
                  </b-input-group>
                    <p style="color:red;font-size:12px">Ingrese un correo y pulse ENTER, para agregarlo a la lista.</p>
                  <template v-if="!sindoc" >
                   <h5 class="separacionCorreo">
                    <b-badge
                      v-for="(item, index) in listaCorreos"
                      :key="index"
                      pill
                      variant="secondary"
                      @click="removeCorreo(index)"
                      class="mr-2"
                      >
                      {{item}}
                      <i class="fa fa-times borrarcorreo"></i>
                    </b-badge>
                  </h5>
                  </template>
                  <template v-else>
                    <h5 class="separacionCorreo"><b-badge  v-for="(item, index) in listaCorreos" 
                     :key="index" 
                     pill 
                     variant="secondary" 
                     class="mr-2"
                     >
                     {{item}}                    
                     </b-badge>
                    </h5>
                  </template>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template><br>
        <template>
          <b-tabs content-class="mt-3">
            <b-tab title="Contactos" active>
              <b-table responsive 
                  :busy="isBusy"
                  :small="small"
                  :outlined="outlined"
                  :striped="striped"
                  :items="contacts"
                  :fields="contacts_fields"
                  :current-page="pactual"
                  :per-page="limite"            
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  >
                  <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong> Cargando...</strong>
                  </div>
                  <template slot="acciones" slot-scope="row">
                      <b-button-group>
                          <b-button v-b-tooltip.hover variant="primary" @click="editContact(row.item)"><i class="fa fa-pencil-alt" title="Editar Cliente"></i></b-button>
                          <b-button @click="preDeleteContact(row.item)" v-b-tooltip.hover variant="danger"><i class="fa fa-trash" title="Eliminar Cliente"></i></b-button>
                      </b-button-group>
                  </template>
                  <template slot="adicionales" slot-scope="row">
                     <h5><b-badge v-for="(item, index) in row.item.tipoContacto" :key="index" pill variant="secondary" class="mr-2">{{item}}</b-badge></h5>
                  </template>
              </b-table>
            </b-tab>
            <b-tab title="Estado de Cuenta">
              <estado v-if="mostrar" :datos="datos"></estado>
            </b-tab>
          </b-tabs>
        </template><br>
        <template>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="9"></b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="2">
              <b-button v-b-modal.newcontact1 variant="primary" @click="newContact()"><i class="fa fa-plus"></i> Nuevo Contacto</b-button>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="1">
              <b-button variant="danger" @click="backView()"><i class="fa fa-chevron-circle-left btnatras"> Atras</i></b-button>
            </b-col>
          </b-row>
          <b-modal id="newcontact1" :title="title" v-model="nuevocontacto" size="lg">
            <div role="group">
                <b-row>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                        <b-input-group>
                            <b-form-input class="input-requerido" v-model="contacto.nomcontacto" placeholder="Nombres (*)"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                        <b-input-group>
                            <b-form-input class="input-requerido" v-model="contacto.apcontacto" placeholder="Apellidos (*)"></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                        <b-form-group
                          id="input-group-1"
                          label-for="input-1"
                          description="Ingrese un correo electronico. Ejemplo. correo@gmail.com"
                        >
                          <b-form-input
                            id="input-1"
                            v-model="contacto.emailcontacto"
                            type="email"
                            required
                            placeholder="Ingresa Correo"
                          ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                        <b-input-group>
                            <b-form-input v-model="contacto.telfcontacto" placeholder="Telefono"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                        <b-input-group>
                            <b-form-input v-model="contacto.cargo" placeholder="Cargo"></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row><br>
                <hr>  
                <b-row>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                      <b-form-group
                          id="input-group-1"
                          label-for="input-1"
                          description="Ingrese datos adicionales y presione ENTER. Ej. Encargado de Almacen"
                        >
                          <b-form-input
                            id="input-1"
                            v-model="contacto.tipocontacto"
                            @keyup.enter="addTipoContacto()"
                            type="text"
                            required
                            placeholder="Adicionales"
                          ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                        <b-list-group>
                          <b-list-group-item v-for="(item, index) in listaTipoContactos" :key="item">
                            <b-row>
                              <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="9">
                                 {{ item }}
                              </b-col>
                              <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                                <b-button v-b-tooltip.hover variant="danger" @click="deleteTipoContacto(index)"><i class="fa fa-trash" title="Eliminar Tipo Contacto"></i></b-button>
                              </b-col>  
                            </b-row>
                          </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row><br>
            </div>
            <div slot="modal-footer" class="w-100">
              <template v-if="modalInsertUpdateC === 1">
                <template v-if="validContact()">
                    <template>
                        <b-btn size="sm" v-if="verifycontact" class="float-right" variant="primary" @click="addUpdateContact('1')">
                            Guardar
                        </b-btn>
                        <b-btn size="sm" v-else class="float-right" variant="secondary">
                            <i class="fa fa-spin fa-spinner"></i> Guardando ...
                        </b-btn>
                    </template>
                </template>
                <template v-else>
                    <div class="text-right">
                        <b-btn size="sm" class="btn btn-secondary" disabled><i class="fa fa-send"></i> Guardar</b-btn>
                    </div>
                </template>
              </template>
              <template v-else-if="modalInsertUpdateC === 2">
                <template v-if="validContact()">
                    <template>
                        <b-btn size="sm" v-if="verifycontact" class="float-right" variant="warning" @click="addUpdateContact('2')">
                            Actualizar
                        </b-btn>
                        <b-btn size="sm" v-else class="float-right" variant="secondary">
                            <i class="fa fa-spin fa-spinner"></i> Actualizando ...
                        </b-btn>
                    </template>
                </template>
                <template v-else>
                    <div class="text-right">
                        <b-btn size="sm" class="btn btn-secondary" disabled><i class="fa fa-send"></i> Actualizar</b-btn>
                    </div>
                </template>
              </template>
                
            </div>
        </b-modal>
        <b-modal id="newdirection1" title="Agregar Direcciones" size="lg">
          <b-row v-if="ubigeoMostrar">
            <b-col cols="2">
              <b-button @click="mostrarUbigeo()"><i class="fa fa-suitcase"> Origen</i></b-button>
            </b-col>
            <b-col cols="2">
              <b-form-input v-model="captureUbigeo"></b-form-input>
            </b-col>
            <b-col cols="6">
                  <b-input-group size="md" >
                    <b-form-input
                      class="input-requerido"
                      type="text"
                      v-model="direccionTercero"
                      required
                      maxlength="100" 
                      placeholder="Agregar Dirección"
                  ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col>
                <template v-if="!editandodireccion">
                  <b-btn
                    :disabled="direccionTercero ==''"
                    size="sm"
                    class="float-right"
                    variant="primary"
                    @click="addDirection()"
                  >Guardar
                  </b-btn>
                </template>
                <template v-else>
                  <b-button variant="warning" @click="editDireccion()">
                    Editar Direccion                    
                  </b-button>
                </template>   
              </b-col>
          </b-row>
          <b-row v-else> 
              <b-col cols="3">
                  <template>           
                    <select class="custom-select mr-sm-2" v-model="departamentoUbigeo">
                      <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{departamento.nombre}} </option>
                    </select>
                  </template>
                </b-col>
                <b-col cols="3">
                  <template>
                    <div v-if="!provOrigen">
                      <b-form-input 
                          type="text"
                          disabled
                          placeholder="Selecciona una Provincia...">
                      </b-form-input>
                    </div>
                    <div v-else-if="provOrigenCargando">
                        Cargando <i class="fa fa-spin fa-spinner"></i>
                    </div>
                    <div v-else>
                      <select class="custom-select mr-sm-2" v-model="provinciaUbigeo" >
                        <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                      </select>
                    </div>
                  </template>
                </b-col>
                <b-col cols="3">
                <template>
                  <div v-if="!distOrigen">
                    <b-form-input 
                        type="text"
                        disabled
                        placeholder="Selecciona una Distrito...">
                    </b-form-input>
                  </div>
                  <div v-else-if="distOrigenCargando">
                    Cargando <i class="fa fa-spin fa-spinner"></i>
                  </div>
                  <div v-else>
                    <select class="custom-select mr-sm-2"  v-model="distritoUbigeo">
                      <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{distrito.nombre}}</option>
                    </select>
                  </div>
                </template>
                </b-col>
                <b-col cols="2">
                  <b-button @click="ocultarUbigeo()" >Atrás <i class="fas fa-backward"></i></b-button>
                </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-table responsive
                  :busy="isBusy"
                  :small="small"
                  :outlined="outlined"
                  :striped="striped"
                  :items="directions"
                  :fields="directions_fields"
                  :current-page="pactual"
                  :per-page="limite"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection">
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                  <template slot="elegir" slot-scope="row">
                    <b-form-group>
                      <b-form-radio
                        v-model="selected"
                        :value="row.index"
                        @change="selectedDirection(row.item, row.index)"
                      ></b-form-radio>
                    </b-form-group>
                  </template>
                  <template slot="acciones" slot-scope="row">
                    <b-button
                      class="buttonaccion"
                      variant="primary"
                      @click="setValueDireccion(row.item)"
                      title="Editar direccion"
                    >
                      <i class="fa fa-pencil-alt"></i>
                    </b-button>
                    <b-button
                      class="buttonaccion"
                      variant="danger"
                      @click="preDeleteDireccion(row.item)"
                      title="Eliminar direccion"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </template>
              </b-table>
            </b-col>
          </b-row>
          <template v-if="cambiarDireccion">
              <b-btn
                size="sm"
                class="float-right marginleft"
                variant="warning"
                @click="cambiarDireccionDefault()"
              >Cambiar Direccion Predeterminada</b-btn>
            </template>
        </b-modal>
    </template>
    <vue-snotify></vue-snotify> 
  </div>
</template>

<script>
import axios from 'axios'
import Estado from '@/components/gestion/EstadoCuenta'
import { Departamentos } from '@/shared/utils';
    export default {
      name: 'DetalleTerceros',
      props: ['idCustomer','customerData'],
      components: {
        Estado
      },
      data: () => {
        return {
          mostrar: false,
          datos: {
            tipo: 2,
            documento: ''
          },
          observaciones: '',
          modalInsertUpdateC: 1,
          isBusy: false,
          verifycontact: true,
          title: 'Agregar Nuevo Contacto',
          nuevocontacto: false,
          limite: 10,
          orden: 'desc',
          striped: true,
          outlined: true,
          small: true,
          desde: '',
          hasta: '',
          total: '',
          pactual: 1,
          contacts: [],
          sortBy: null,
          sortDesc: false,
          sortDirection: 'asc',
          currentPage: 1,
          totalRows: null,
          contacts_fields: [
              {key: 'nomContacto', label: 'Nombres', sortable: true},
              {key: 'apContacto', label: 'Apellidos', sortable: true},
              {key: 'telfContacto', label: 'Telefono', sortable: true},
              {key: 'emailContacto', label: 'Correo', sortable: true},
              {key: 'cargo', label: 'Cargo', sortable: true},
              {key: 'adicionales', label: 'Adicionales', sortable: true},
              {key: 'acciones', label: 'Acciones'}
          ],
          listaTipoContactos: [],
          contacto: {
            apcontacto: '',
            nomcontacto: '',
            emailcontacto: '',
            telfcontacto: '',
            tipocontacto: '',
            cargo: ''
          },
          idContacto: '',
          direccionTercero: "",
          directions: [],
          directions_fields: [
            { key: "direccion", label: "Dirección"},
            { key: "elegir", label: "Elegir" },
            { key: "acciones", label: "Acciones" }
          ],
          isBusy: false,
          idTercero: "",
          idDireccion: "",
          direccionTerceroDefecto: "",
          cambiarDireccion: false,
          selected: true,
          customers:[],
          direccionActual:'',
          editandodireccion: false,
          direccionActuaEdit:{},
          direccionActuaDelete:{},
          value:[],
          obsDisabled:true,
          obsDisabledPro:true,
          obsDisabledNV:true,
          celular:true,
          telefono:true,
          correo: "",
          listaCorreos: [],
          sindoc: true,
          listaTag:[],
          tag1:'',
          tag2:'',
          observacionesPro:'',
          observacionesNV:'',
          Obs:[],
          mostrarEditRazonSocial:false,
          ubigeoMostrar:true,
          departamentoUbigeo:'00',
          listDepartamento: Departamentos,
          provOrigen:false,
          provOrigenCargando:false,
          provinciaUbigeo:'',
          listProvinceOrigen: [],
          distOrigen:false,
          distOrigenCargando:false,
          distritoUbigeo:'',
          listDistrictOrigen: [],
          captureUbigeo:'',
          customerDataDatos:[],
        }
      },
      mounted() {
        this.listContactos(),
        this.initDocument()
        this.listTerceros()
        this.listTag()
      },
      computed:{
        stateCorreo() {
          let expreg = new RegExp(
            "^[a-zA-Z0-9-_.]{1,}@[a-zA-Z0-9-_]{1,}.[a-z]{2,3}(.[a-z]{2})?$"
          );
          if (!expreg.test(this.correo)) {
            return false;
          } else {
            return true;
          }
        },
        invalidFeedbackCorreo() {
          if(this.correo.length == 0) {
            return "Ingresa un correo válido";
          }else{
            return "";
          }
        },
        validFeedbackCorreo() {
          return this.stateCorreo === true ? "Perfecto" : "";
        }
      },
      watch: {
        nuevocontacto: function () {
            if(!this.nuevocontacto){
                this.contacto.apcontacto = ''
                this.contacto.nomcontacto = ''
                this.contacto.emailcontacto = ''
                this.contacto.telfcontacto = ''
                this.listaTipoContactos = []
                this.contacto.cargo = ''
            }   
        },
        departamentoUbigeo(){
          this.provOrigen = true;
          this.searchProvinceOrigen();
        },
        provinciaUbigeo(){
          this.distOrigen = true,
          this.distOrigenCargando = true,
          this.searchDistrictOrigen(this.distOrigenCargando)
        },
        distritoUbigeo() {
          this.distOrigenCargando = false,
          this.captureUbigeo = this.departamentoUbigeo + this.provinciaUbigeo + this.distritoUbigeo.codDistrito
          // this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
          // this.modalUbigeoPartida = false
        }
      },
      methods: {
        initDocument: function () {
          this.datos.documento = this.customerData.documento
          this.mostrar = true
        },
        editarDireccion: function () {
          axios
          .post(process.env.VUE_APP_API_URL + 'direcciones/actualizar', {
              token: this.$store.getters.userToken,
              id: '',
              iddireccion: '',
              ugigeo: '',
              direccion: ''
          })
          .then(response => (
              this.customerData = response.data.response,
              this.activate = true
          ))
          .catch(error => (
              this.changeView = 0,
              this.activate = false
          ))
        },
        validContact: function () {
          if(this.contacto.nomcontacto != ''){
              return true
          }else{
              return false
          }
        },
        newContact: function () {
          this.modalInsertUpdateC = 1,
          this.nuevocontacto = true
        },
        editContact: function (value) {
          this.nuevocontacto = true,
          this.modalInsertUpdateC = 2,
          this.contacto.apcontacto = value.apContacto,
          this.contacto.nomcontacto = value.nomContacto,
          this.contacto.emailcontacto = value.emailContacto,
          this.contacto.telfcontacto = value.telfContacto,
          this.listaTipoContactos = value.tipoContacto,
          this.contacto.cargo = value.cargo,
          this.idContacto = value.idContacto
        },
        dataContacto: function () {
          this.sindoc = false
          axios
          .post(process.env.VUE_APP_API_URL + 'terceros/buscar/1', {
              token: this.$store.getters.userToken,
              filtro: 'id',
              p: this.customerData.idTercero
          })
          .then(response => (
              this.customerDataDatos = response.data.response,
              this.responseEditCliente(this.customerDataDatos),
              this.activate = true
          ))
          .catch(error => (
              this.changeView = 0,
              this.activate = false
          ))
        },
        responseEditCliente(value){
          if (value.emailEnvio != null && value.emailEnvio.length > 0) {
            this.listaCorreos = value.emailEnvio;
          } else {
            this.listaCorreos = [];
          }
        },
        deleteTipoContacto: function (index) {
          this.listaTipoContactos.splice(index,1)
        },
        addTipoContacto: function () {
          if(this.contacto.tipocontacto != ''){
            this.listaTipoContactos.push(this.contacto.tipocontacto),
            this.contacto.tipocontacto = ''
          }else{
            this.$snotify.error('Debe ingresar un adicional', 'Error')
          }
        },
        preDeleteContact: function (value) {
          swal({
            title: "Seguro de borrar a "+value.nomContacto,
            text: "Este proceso no se puede revertir!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            })
            .then((willDelete) => {
            if (willDelete) {
                this.deleteContact(value),
                this.isBusy = true
            }
          });
        },
        deleteContact: function (value) {
          axios
            .post(process.env.VUE_APP_API_URL + 'terceros/contactos/eliminar', {
                token: this.$store.getters.userToken,
                idtercero: value.idTercero,
                idcontacto: value.idContacto
            })
            .then(response => (
              this.$snotify.success(response.data.msg, 'Éxito'),
              this.listContactos()
            ))
            .catch(error => (
              this.$snotify.error(error.response.data.msg, 'Error')
            ))
        },
        addUpdateContact: function (value) {
          this.verifycontact = false,
          this.nuevocontacto = true
          let addupdatecontacto = ''
          if(value == '1'){
            addupdatecontacto = 'terceros/contactos/insertar',
            this.modalInsertUpdateC = 1
          }else if(value == '2'){
            addupdatecontacto = 'terceros/contactos/actualizar',
            this.modalInsertUpdateC = 2
          }
          axios
            .post(process.env.VUE_APP_API_URL + addupdatecontacto, {
                token: this.$store.getters.userToken,
                idtercero: this.idCustomer,
                idcontacto: this.idContacto,
                apcontacto: this.contacto.apcontacto,
                nomcontacto: this.contacto.nomcontacto,
                emailcontacto: this.contacto.emailcontacto,
                telfcontacto: this.contacto.telfcontacto,
                tipocontacto: this.listaTipoContactos,
                cargo: this.contacto.cargo
            })
            .then(response => (
              this.$snotify.success(response.data.msg, 'Éxito'),
                this.nuevocontacto = false,
                this.verifycontact = true,
                this.listContactos(),
                this.initModalContacto()
            ))
            .catch(error => (
                this.nuevocontacto = false,
                this.verifycontact = true
            ))
        },
        initModalContacto: function () {
            this.contacto.apcontacto = ''
            this.contacto.nomcontacto = ''
            this.contacto.emailcontacto = ''
            this.contacto.telfcontacto = ''
            this.listaTipoContactos = []
            this.contacto.cargo = ''
        },
        cargar: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'terceros/contactos/listar', {
                token: this.$store.getters.userToken,
                id: this.idCustomer
            })
            .then(response => (
                this.contacts = response.data.response.data,
                this.cargando = false
            ))
            .catch(error => (
                this.cargando = false
            ))
        },
        listContactos: function () {
            this.isBusy = true
            axios
            .post(process.env.VUE_APP_API_URL + 'terceros/contactos/listar', {
                token: this.$store.getters.userToken,
                id: this.idCustomer
            })
            .then(response => (
                this.contacts = response.data.response.data,
                this.isBusy = false
            ))
            .catch(error => {
              this.isBusy = false
            })
        },
        backView: function () {
          this.changeTab(0)
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        },
        validContact: function () {
          if(this.contacto.nomcontacto != ''
            ){
            return true
          }else{
            return false
          }
        },
        mostrarDirecciones(){
          if (this.customerData !='') {
              this.idTercero = this.customerData.idTercero
          }
          this.isBusy = true;
          axios
          .post(process.env.VUE_APP_API_URL + "terceros/direcciones/listar", {
              token: this.$store.getters.userToken,
              id: this.idTercero
            })
          .then(response =>(
              (this.directions = response.data.response.data),
              this.direccionDefecto(),
              (this.isBusy = false)
          ))
          .catch(error => (
            (this.isBusy = false)
          ));
        },
        addDirection: function() {
          if (this.customerData !='') {
              this.idTercero = this.customerData.idTercero
          }
          this.isBusy = true;
          if(this.direccionTercero){
            axios
            .post(process.env.VUE_APP_API_URL + "terceros/direcciones/insertar", {
                token: this.$store.getters.userToken,
                id: this.idTercero,
                ubigeo: this.captureUbigeo,
                direccion: this.direccionTercero
            })
            .then(response => (
                (this.captureUbigeo = ""),
                (this.direccionTercero = ""),
                this.isBusy = false,
                this.mostrarDirecciones()
            ))
            .catch(error => (
                (this.isBusy2 = false),
                (this.isBusy = true)
            ));
          } 
        },
        selectedDirection: function(value, index) {
          (this.idDireccion = value.idDireccion), (this.cambiarDireccion = true);
        },
        cambiarDireccionDefault: function() {
          if (this.customerData !='') {
              this.idTercero = this.customerData.idTercero
          }
          this.isBusy = true;
          axios
          .post(
            process.env.VUE_APP_API_URL + "terceros/direcciones/predeterminar",
              {
                token: this.$store.getters.userToken,
                idtercero: this.idTercero,
                iddireccion: this.idDireccion
              })
          .then(response => (
              this.listTerceros(),
              (this.isBusy = false),
              (this.cambiarDireccion = false)    
          ))
          .catch(error => (
            (this.isBusy = false), 
            (this.cambiarDireccion = false))
          );
        },
        direccionDefecto: function() {
          if (this.directions.principal == 1) {
            this.selected = this.directions.idDireccion;
          }
        },
        listTerceros: function() {
          axios
            .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
              token: this.$store.getters.userToken,
            })
            .then(response => (
                (this.customers = response.data),
                this.filtrodata()
              ))
            .catch(error =>(
              console.log()
            ))
        },
        filtrodata(){
          let v1 = this.customerData.idTercero
          let dirActual = ''
          let Obs = []
          this.customers.forEach(function(element){
            if(v1 == element.idTercero){
              dirActual = element.domFiscal
              Obs = element.obsDocs
            }
          })
          this.direccionActual = dirActual
          this.customerData.obsDocs = Obs
          return dirActual
        },
        setValueDireccion: function(value) {
          (this.direccionTercero = value.direccion),
          (this.direccionActuaEdit = value),
          (this.captureUbigeo = value.ubigeo),
          (this.editandodireccion = true),
          (this.edicciondir = true)    
        },
        editDireccion: function() {
          if (this.customerData !='') {
              this.idTercero = this.customerData.idTercero
          }
          this.editandodireccion = true;
          axios
            .post(process.env.VUE_APP_API_URL + "terceros/direcciones/actualizar", {
              token: this.$store.getters.userToken,
              id: this.idTercero,
              iddireccion: this.direccionActuaEdit.idDireccion,
              ubigeo: this.captureUbigeo,
              direccion: this.direccionTercero
            })
            .then(
              response => (
                this.$snotify.success(response.data.msg, "Exito"),
                this.mostrarDirecciones(),
                (this.edicciondir = false),
                (this.editandodireccion = false),
                this.direccionTercero = "",
                this.captureUbigeo = "",
                this.listTerceros()
              ))
            .catch(error => {
              this.$snotify.error(error.response.data.msg, "Error"),
                (this.edicciondir = false),
                (this.editandodireccion = false);
            });
        },
         preDeleteDireccion: function(value) {
          this.$swal({
            title: "Eliminar Dirección",
            text: "Seguro de eliminar la direccion " + value.direccion + "???",
            icon: "error",
            buttons: true,
            dangerMode: true
          }).then(willDelete => {
            if (willDelete) {
              (this.direccionActuaDelete = value), this.deleteDireccion();
            } else {
              this.$snotify.error(error.response.data.msg, "Error");
            }
          });
        },
        deleteDireccion: function() {
          axios
            .post(process.env.VUE_APP_API_URL + "terceros/direcciones/eliminar", {
              token: this.$store.getters.userToken,
              id: this.direccionActuaDelete.idTercero,
              iddireccion: this.direccionActuaDelete.idDireccion
            })
            .then(
              response => (
                this.$snotify.success(response.data.msg, "Exito"),
                this.mostrarDirecciones(),
                this.listTerceros()
              )
            )
            .catch(error => {
              this.$snotify.error(error.response.data.msg, "Error");
            });
        },
        editarObs(){
          this.obsDisabled = false;
        },
        editarObsPro(){
          this.obsDisabledPro = false;
        },
        editarObsNV(){
          this.obsDisabledNV = false;
        },
        editarCelular(){
          this.celular = false;
        },
        editarTelefono(){
          this.telefono = false;
        },
        editarRazonSocial(){
          this.mostrarEditRazonSocial = true;
        },
        addCorreo: function() {   
          if (this.correo != "" && this.stateCorreo) {
            this.listaCorreos.push(this.correo), (this.correo = "");
          }else{
            this.$snotify.error("Debe ingresar un correo valido", "Error");
          }
        },
        removeCorreo: function(index) {
          this.listaCorreos.splice(index, 1);
        },
        editarCorreo(){
          this.sindoc = false
        },
        actualizarDatos(){
          if(this.customerData.obsDocs !=null && this.customerData.obsDocs[0].obs !=''){
            this.observacionesPro = this.customerData.obsDocs[0].obs 
          }
          if(this.customerData.obsDocs !=null && this.customerData.obsDocs[1].obs !=''){
            this.observacionesNV = this.customerData.obsDocs[1].obs 
          }

          let observacionesDocumentos = [
            {
              doc: 'Proforma',
              obs: this.observacionesPro,
            },
            {
              doc: 'Nota de Venta',
              obs: this.observacionesNV,
            } 
          ]

          this.customerData
          axios
          .post(process.env.VUE_APP_API_URL + "terceros/actualizar/1",{
            token: this.$store.getters.userToken,
            tipodocumento: this.customerData.tipoDocumento,
            id: this.customerData.idTercero,
            documento: this.customerData.documento,
            razonsocial: this.customerData.razonSocial,
            direccion: this.direccionActual,
            domfiscal: this.direccionActual,
            tipotercero: 1,
            emailenvio: this.listaCorreos,
            telefono: this.customerData.telefono,
            tag1: this.customerData.tag1,
            tag2: this.customerData.tag2,
            movil1: this.customerData.movil1,
            observaciones: this.customerData.observaciones,
            obsDocs:observacionesDocumentos,
          })
          .then(response=>(
            this.obsDisabled = true,
            this.obsDisabledPro = true,
            this.obsDisabledNV = true,
            this.celular = true,
            this.telefono = true,
            this.sindoc = true,
            this.mostrarEditRazonSocial = false,
            this.listTerceros(),
            this.$snotify.success("Dato Actualizado", "Éxito")
          ))
          .catch(error=>(
            console.log(error.response.data)
          ))
        },
        listTag: function() {
          this.dataContacto()
          axios
            .post(process.env.VUE_APP_API_URL + "tag/listar", {
              token: this.$store.getters.userToken,
              limit: "40",
              order: "desc"
            })
            .then(
              response => (
                (this.listaTag = response.data.data)
              )
            )
            .catch(error => (this.$snotify.error("Error")));
        },
        mostrarUbigeo(){
          this.ubigeoMostrar = false
        },
        ocultarUbigeo(){
          this.ubigeoMostrar = true
        },
        searchProvinceOrigen: function () {
          this.provOrigenCargando = true
          axios
          .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                token: this.$store.getters.userToken,
              department: this.departamentoUbigeo
          })
          .then(response => (
              this.provOrigenCargando = false,
              this.listProvinceOrigen = response.data                       
          ))
          .catch(error => {})
        },
        searchDistrictOrigen: function (value) {
          this.distOrigenCargando = value   
          axios
          .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: this.departamentoUbigeo,
            province: this.provinciaUbigeo
          })
          .then(response => (
            this.listDistrictOrigen = response.data,
            this.distOrigenCargando = false
          ))
          .catch(error => {})
        },
      }
    }
</script>

<style>
.stylelogocliente{
  height: 50px;
  width: 200px;
}
.razonSocialCliente{
  margin-top: 25px;
}
.separacionCorreo{
  margin-top: 10px;
}
.index1{
  z-index: 1;
  background-color: white;
  position: absolute;
}
.index2{
  z-index: 100;
  color: #006eae;
  font-size: 19px;
  position: relative;
  margin-left: 97%;
}
.sinresultados {
    padding: 0 5px 0 5px;
  }
</style>